module.exports = __webpack_public_path__ + "static/media/gry-edukacyjne-dla-13-latka-14-latka.df4906f2.png";